<template>
  <ion-page id="signin-page">
    <ion-content>
  
      <div v-if="showState == SHOW_EXPLAINTOUR">
        <ExplainTour :screen="explainTourScreen"
                      :wordsSpoken="explainTourWordsSpoken"
                      :wordsSpokenTrigger="explainTourWordsSpokenTrigger"
                    @toolbar-click="explainTourToolbarClick" />
      </div>

      <div v-show="showState == SHOW_LOGIN">
        <TopLine :style="styleTopline" :title="signInTitle" :microphoneIsMuted="microphoneIsMuted" @topline-click="toplineClick"/>

        <div :style="styleMiddle">
          <ion-item>
            <h5>{{ message }}</h5>
          </ion-item>
          <ion-item v-if="showEmailPassword">
            <ion-input :label="emailString" label-placement="fixed" 
                      :placeholder="emailPlaceholderString" :value="email"
                      @ionInput="emailInputChange">
            </ion-input>
          </ion-item>

          <ion-item v-if="showEmailPassword">
            <ion-input :label="passwordString" type="password" label-placement="fixed" 
                      :placeholder="passwordPlaceholderString" :value="password"
                      @ionInput="passwordInputChange">
                <ion-input-password-toggle slot="end"></ion-input-password-toggle>
            </ion-input>
          </ion-item>
        </div>
        <ToolBar :style="styleToolbar" :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
      </div>
    </ion-content>
  </ion-page>
  
</template>

<script setup>

  import { IonGrid,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';
  import { computed } from "@vue/reactivity"

  import { ref , watch } from 'vue';
  import ExplainTour from '@/components/ExplainTour.vue'
  import { useGetData , generateErrorAlertText } from '@/composables/getData.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { doStartupCheck } from '@/composables/startupCheck.js'
  import ToolBar from '@/components/ToolBar.vue'
  import { parseWordsSaid } from '@/composables/wordlistSupport.js'

   import { buildStyleToolbar, buildStyleTopline,buildStyleMiddle,availableWidthHeight, 
    calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

  import TopLine from '@/components/TopLine.vue'
  import { translateEnglishWords, translatePhrase } from '@/composables/translation.js';

  const emit = defineEmits(['where-next','word-list','mic-is-muted'])

  const props = defineProps({
      wordsSaid : {
        type : String,
        default : ""
      },
      wordsSaidTrigger : {
        type : Number,
        default : 0
      }
    })

  const wordsSaid = computed({get() {return props.wordsSaid}})
  const wordsSaidTrigger = computed({get() {return props.wordsSaidTrigger}})

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  const explainTourWordsSpoken = ref("")
  const explainTourScreen = ref("")
  const explainTourWordsSpokenTrigger = ref(0)
  
  const isDark = ref(connectionStore.getDarkmode != "light")
  const cookie = connectionStore.getCookie
  const dummy = connectionStore.getDummy

  const subjectForEmail = "Verbal Chess - " + translatePhrase("Password Reset Request")
  const toEmail = "Verbal Chess" + translateEnglishWords("User")
  const greetingForEmail = translateEnglishWords("Hi")
  const topPartOfEmail = translatePhrase("To reset your password within the 'Verbal Chess' website, either click on the link below or copy it into your browser and it will take you to a password reset page.")
  const middlePartOfEmail = translatePhrase("If that doesn't work, this is the old link that does the same thing but uses the Chessvis.com site. Then you can manually go back to the new web site.")
  const endPartOfEmail = translatePhrase("If you have any questions, please email me at")

  // if user is logged in, go to home screen
  if (cookie != "" && dummy == 0) {
    emit("where-next","/")

    //router.replace({ path: '/' })
  }

  const wordlistLogin = "command done sign log in forgot password mute listen"
  const wordlist = ref(wordlistLogin)
  emit("word-list",wordlistLogin)
  const wordlistTrigger = ref(0)

  const emailStorage = connectionStore.getEmailAddress
  const email = ref( (emailStorage == null) ? "" : emailStorage)
  
  const password = ref("")

  const signInTitle = ref(translateEnglishWords("Sign In"))
  const emailString = ref(translateEnglishWords("Email"))
  const passwordString = ref(translateEnglishWords("Password"))
  const emailPlaceholderString = ref(translateEnglishWords("Enter email"))
  const passwordPlaceholderString = ref(translateEnglishWords("Enter password"))

  const message = ref(translatePhrase("Please Sign In -- (Note: Email/Password same as Chessvis)"))
  const showEmailPassword = ref(true)

  const SHOW_LOGIN = 0
  const SHOW_EXPLAINTOUR = 1
  const showState = ref(SHOW_LOGIN)

  const TOOLBAR_LOGIN = 0
  const TOOLBAR_FORGOT_PASSWORD = 1
  const TOOLBAR_EXPLAIN = 2

  const toolbarElements = [
    { index : TOOLBAR_LOGIN, label : translateEnglishWords("Sign in") ,disabled : false},
    { index : TOOLBAR_FORGOT_PASSWORD, label : translateEnglishWords("Forgot Password") ,disabled : false},
   // { index : TOOLBAR_EXPLAIN, label : "Explain" ,disabled : false},
  ]
  const toolbarTrigger = ref(0)

  const explainTitle = ref("")
  const explainMessage = ref("")

  const styleToolbar = ref(buildStyleToolbar(availableWidthHeight()))
  const styleTopline = ref(buildStyleTopline(availableWidthHeight()))
  const styleMiddle = ref(buildStyleMiddle(availableWidthHeight()))

  const microphoneIsMuted = ref(connectionStore.getMicrophoneIsMuted)
  emit("mic-is-muted",microphoneIsMuted.value)

  watch(wordsSaidTrigger, (newVal,oldVal) => {
     //console.log('*********** words said ',props.wordsSaid)
     processWords(props.wordsSaid)
   })

  watch(() => windowSizeStore.getWindowSize, () => {
    styleToolbar.value = buildStyleToolbar(availableWidthHeight())
    styleTopline.value = buildStyleTopline(availableWidthHeight())
    styleMiddle.value = buildStyleMiddle(availableWidthHeight())
  })

   // START Explain Tour Routines

// START Explain Tour Routines

function explainTourInitialize(pageName,errorText) {
    //console.log("in explain tour initialize")
    showState.value = SHOW_EXPLAINTOUR
    explainTourScreen.value = (errorText == null) ? pageName : ("ERROR:" + errorText);
    wordlist.value = connectionStore.getExplainTourWords
    emit("word-list",wordlist.value)
    wordlistTrigger.value++
  }

  function explainTourToolbarClick(whatClicked) {
    switch (whatClicked) {
      case "mute" :
        microphoneIsMuted.value = true 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(true)
        break
      case "listen" :
        microphoneIsMuted.value = false 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(false)
        break
      case "done" :
        showState.value = SHOW_LOGIN
        wordlist.value = wordlistLogin
        emit("word-list",wordlist.value)
        wordlistTrigger.value++
        break
    }
  }

  // END Explain Tour Routines

// END Explain Tour Routines

function toplineClick(whatClicked) {
    //console.log("topline",whatClicked)
    switch (whatClicked) {
      case "done" :
        processWords("command done")
        break;
      case "microphone" :
        microphoneIsMuted.value = !microphoneIsMuted.value 
        emit("mic-is-muted",microphoneIsMuted.value)
        connectionStore.setMicrophoneIsMuted(microphoneIsMuted.value)
        break

    }
  }

  function emailInputChange(ev) {
    //console.log("email ",ev)
    const value = ev.target.value;
    ///console.log("email",value)
    email.value = value.trim()
  }

  function passwordInputChange(ev) {
    //console.log("password ",ev)
    const value = ev.target.value;
    //console.log("password",value)
    password.value = value.trim()
  }

  function processJsonResponse (json) {
    //console.log(" in callback",json)
    if (json.hasOwnProperty('error')) {
      explainTourInitialize(null,generateErrorAlertText(json))
      return;
    }
    switch (json['stat']) {
      case 'e' :
        message.value = translatePhrase("Email is not in the system")
        break;
      case 'p' :
        message.value = translatePhrase("Password is incorrect")
        break;
      case 'g' :
        const cookie = json['cookie']
        connectionStore.setUserCookieDummy(cookie,"0")
        connectionStore.setEmailAddress(email.value)

        emit("where-next","/main_from_login")

        break
    }
  }

  function doLogin () {
    if (email.value == "") {
      message.value = translatePhrase("Please enter your email address")
      return
    }
    if (password.value == "") {
      message.value = translatePhrase("Please enter your password")
      return
    }
    message.value = translateEnglishWords("checking") + "...."
    var formData = { e : email.value , p: password.value }
    useGetData("mobile_login.php", formData, processJsonResponse)
  }

  function processForgotJsonResponse (json) {
    //console.log(" in forgot callback",json)
    if (json.hasOwnProperty('error')) {
      explainTourInitialize(null,generateErrorAlertText(json))
      return;
    }
    switch (json['stat']) {
      case 'e' :
        message.value = translatePhrase("Email is not in the system")
        break;
      case 'g' :
        message.value = translatePhrase("Password Reset Email Sent")
        break
    }
  }

  function doForgot () {
    if (email.value == "") {
      message.value = translateEnglishWords("Please enter your email address")
      return
    }

  const subjectForEmail = "Verbal Chess - " + translatePhrase("Password Reset Request")
  const toEmail = "Verbal Chess" + translateEnglishWords("User")
  const greetingForEmail = translateEnglishWords("Hi")
  const topPartOfEmail = translatePhrase("To reset your password within the 'Verbal Chess' website, either click on the link below or copy it into your browser and it will take you to a password reset page.")
  const middlePartOfEmail = translatePhrase("If that doesn't work, this is the old link that does the same thing but uses the Chessvis.com site. Then you can manually go back to the new web site.")
  const endPartOfEmail = translatePhrase("If you have any questions, please email me at")

    message.value = translateEnglishWords("checking") + "...."
    var formData = { 
      e : email.value,
      subject : subjectForEmail,
      to_name : toEmail,
      greeting : greetingForEmail,
      top : topPartOfEmail,
      middle : middlePartOfEmail,
      end : endPartOfEmail
    }
    useGetData("send2_verbal_password_reset.php", formData, processForgotJsonResponse)
  }

  function toolbarClick(arrayIndex) {
    switch (arrayIndex) {
      case TOOLBAR_LOGIN :
        processWords("command log in ")
        break
      case TOOLBAR_FORGOT_PASSWORD :
        processWords("command forgot")
        break
      case TOOLBAR_EXPLAIN :
        processWords("command explain")
        break
    }
  }

  function processWords(text) {

    if (showState.value == SHOW_EXPLAINTOUR) {
      explainTourWordsSpoken.value = text
      explainTourWordsSpokenTrigger.value++
      return;
    }
    //console.log("text in Logoff ",text)
    const returnArray = parseWordsSaid(text,parseCommands)
    //console.log("command found",returnArray)

    switch (returnArray[0]) {
      case "explain" :
        explainTourInitialize("signin",null)
      case "done" :
        emit("where-next","/accountmenu")
        break
      case "login" :
        doLogin()
        break
      case "forgot" :
        doForgot()
        break
    }
  }

  function parseCommands(words,currentWordIndex) {
    
    //console.log("in parse commands",words,currentWordIndex)
    var currentWord = (words.length > currentWordIndex) ? words[currentWordIndex] : "xyz"
    var nextWord = (words.length > currentWordIndex+1) ? words[currentWordIndex+1] : "xyz"
    var nextNextWord = (words.length > currentWordIndex+2) ? words[currentWordIndex+2] : "xyz"

    for (var i = 0; i < words.length; i++) {
        if (currentWord == "ignore")
          return ["ignore",""];
        if (currentWord == "explain")
          return ["explain",""];
        if (currentWord == "done")
          return ["done",""]
        if ((currentWord == "log" || currentWord == "sign") && nextWord == "in")
          return ["login",""]
        if (currentWord == "forgot")
          return ["forgot",""]

        currentWord = nextWord;
        nextWord = nextNextWord;
        nextNextWord = (i < words.length - 3) ? words[i + 3] : "xyz";
    }
    return ["ignore",""];
  }

  
</script>

<style scoped>

ion-item {
  margin:10px;
}
</style>